import React from 'react'
import PropTypes from 'prop-types'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'

const TypeProps = {
  id: PropTypes.any,
  name: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  boldOnSelected: PropTypes.bool,
  textMarginOverride: PropTypes.any
}

const RadioButton = ({ id, name, selected, onClick, textMarginOverride=null }) => {
  return (
    <div className={generalStyles.flexRow}>
      <input
        type="radio"
        key={id}
        id={id}
        name={name}
        checked={selected}
        value={name}
        onChange={() => onClick(name)}
        className={textMarginOverride || generalStyles.mr20}
      />
      <label key={id} className={ selected ? fontStyles.psmallboldlsin08blackgraphik15pt : fontStyles.psmalllsin08blackgraphik15pt}>
        {name}
      </label>
    </div>
  )
}

RadioButton.propTypes = {
  ...TypeProps
}

export default RadioButton
